import React from "react";
import { SelectPicker, Form, Loader } from "rsuite";

const CustomSelector = (props: any) => {
  const {
    isSearchable,
    loaderMsg,
    labelName,
    valueKey,
    labelKey,
    listData,
    defaultValue,
    value,
    onChange,
    onSelect,
    onClear,
    isDisable,
    customErrorMsg,
    isRequired,
    ...rest
  } = props;

  return (
    <div>
      {labelName && (
        <div style={{ display: "inline" }}>
          <Form.ControlLabel>
            {labelName}
            {isRequired ? "*" : " "}
          </Form.ControlLabel>
        </div>
      )}
      <div>
        <SelectPicker
          searchable={isSearchable}
          labelKey={labelKey}
          valueKey={valueKey}
          value={defaultValue}
          data={listData}
          disabled={isDisable}
          {...rest}
          onChange={(event: any) => {
            let selectedObj: any;
            listData &&
              listData.length &&
              listData.map((item: any) => {
                if (item[valueKey] === event) {
                  selectedObj = item;
                }
              });
            onChange && onChange(event, selectedObj);
          }}
          onSelect={(event: any) => {
            let selectedObj: any;
            listData &&
              listData.length &&
              listData.map((item: any) => {
                if (item[valueKey] === event) {
                  selectedObj = item;
                }
              });
            onSelect && onSelect(event, selectedObj);
          }}
          onClean={(event: any) => {
            onClear && onClear(event);
          }}
        />

        {loaderMsg !== null &&
          (!listData ||
            (!listData?.length && (
              <>
                <br />
                <Loader
                  size="sm"
                  content={!!loaderMsg ? loaderMsg : "Fetching details..."}
                />
              </>
            )))}

        {!!customErrorMsg && (
          <>
            <br />
            <span style={{ color: "red" }}>{customErrorMsg}</span>
          </>
        )}
      </div>
    </div>
  );
};

export default CustomSelector;
